import React from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'


import {NavBar} from '../navBar/NavBar';
import {Latest} from '../latest/Latest';
import {Labels} from '../labels/Labels';
import {Profiles} from '../labelProfiles/Profiles';
import {News} from '../news/News';
import {About} from '../about/About';
import {MobileNav} from '../Tools/mobileNav/MobileNav';
import {Home} from '../home/Home';
import {Error404} from '../error404/Error404';


class App extends React.Component {
  constructor(props){
    super()
    this.state = {
      displayNavBar: false
    }
    this.handleNavBar = this.handleNavBar.bind(this)
  } 

  // toggle navigation for small screens
  handleNavBar() {
    if (this.state.displayNavBar === false) {
      document.querySelector('.navBar').classList.add('showNav')
      this.setState({displayNavBar: true})
    } else {
      document.querySelector('.navBar').classList.remove('showNav')
      this.setState({displayNavBar: false})
    }
  }





  render() {
    return(
      <Router>
        <NavBar handleNavBar={this.handleNavBar} />
        <MobileNav handleNavBar={this.handleNavBar} />
        <Switch>
          <Route path='/dtn' component={Home} exact />
          <Route path='/latest' component={Latest} exact />
          <Route path='/labels' component={Labels} exact/>
          <Route path='/news' component={News} exact/>
          <Route path='/about' component={About} exact/>
          <Route path='/profile' component={Profiles} />
          
          <Route path='/404' component={Error404} />
          <Redirect to='/404' />
        </Switch>
      </Router>
    );
  }

}


export default App;
